
const App = () => {
  return (
      <p>Familify</p>
  );
}

export default App;
